export default "__VITE_ASSET__Bu3_KERh__"